import $ from 'jquery';
import { getUser } from '~src/user';

const addUserDetailsToNavbar = (user) => {
  let navbarName = '';
  if (user.org_pointer.nome) {
    navbarName = `${user.org_pointer.nome}<br>${user.first_name} ${user.last_name}`;
  } else {
    if (user.first_name && user.last_name) {
      navbarName = `${user.first_name} ${user.last_name}`;
    } else {
      navbarName = user.username;
    }
  }
  $('#sidebar-profile-button').html(navbarName);
  $('#sidebar-profile-name').html(navbarName);
};

export const addOrgDataToNavbar = async () => {
  const { user } = await getUser();
  addUserDetailsToNavbar(user);
};
